import { createEvmActionSource, isHex } from '@pkg/evm'
import { createSolanaActionSource } from '@pkg/solana'
import type { ParseToSources } from '../../types'
import {
  isSupportChain,
  supportChainEvmChainIds,
  supportSolanaChainName,
} from '../constants'
import type { Withdrawal } from './schema'

export const parseWithdrawalHistoriesToSources: ParseToSources<Withdrawal> = (
  data,
) => {
  const sourceSet = new Set<string>()
  for (const item of data) {
    // support chain 以外はスキップ
    if (!isSupportChain(item.chain)) {
      continue
    }

    const chainId = supportChainEvmChainIds[item.chain]
    // evm だったら walletTxId から source 作成して追加
    if (chainId !== undefined && isHex(item.walletTxId)) {
      sourceSet.add(
        createEvmActionSource({ chainId, transactionHash: item.walletTxId }),
      )
    }
    // solana だったら txid から source 作成して追加
    else if (item.chain === supportSolanaChainName) {
      sourceSet.add(createSolanaActionSource({ signature: item.walletTxId }))
    }
  }
  return [...sourceSet]
}
